import apiService from './apiService';

export default (function() {
	var servicePath = '/TrackingEvent';

	function add(token, type) {
		var params = {
			token: token,
			type: type
		};
		const url = servicePath + apiService.paramsToQuery(params);

		return apiService.post(null, url);
	}

	function fetchForEmail(emailId, advisorId, isCampaignEmail) {
		var url = servicePath + '?emailId=' + emailId + '&advisorId=' + advisorId + '&isCampaignEmail=' + isCampaignEmail;

		return apiService.get(url)
			.then(function(data) {
				apiService.parse(data);
				return data;
			});

	}

	return {
		add: add,
		fetchForEmail: fetchForEmail
	};
})();
